import Alpine from 'alpinejs';

Alpine.data('menu', () => ({
    
    is_open: false,
    
    init() {
        var self = this;
        window.addEventListener('menu:toggle', () => self.toggle());
        window.addEventListener('menu:open', () => self.open());
    },

    toggle() {
        this.is_open ? this.close() : this.open();
    },

    open() {
        this.is_open = true;
        //document.body.classList.add('overflow-hidden');
    },

    close() {
        this.is_open = false;
        //document.body.classList.remove('overflow-hidden');
    }
}));